export const images = new Map<string, string>([
    ["marching_ants_gif", "./../../../Images/marching_ants.gif"],
    ["marching_ants_white_gif", "./../../../Images/marching_ants_white.gif"],
]);
